/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Card,
  CardBody,
  Row,
  Container,
  CardImg,
} from "reactstrap";
import { Link } from "react-router-dom";
import SimpleHeader from "components/Headers/SimpleHeader.js";
import Halaman404 from "views/404";
import HeaderTotal from 'components/Headers/HeaderTotal';

export default function SuratJalanAddendum() {
    const warehouse = localStorage.warehouse;
    const username = localStorage.username;
    const token = localStorage.token;
    const [totalItem, setTotalItem] = useState(0);
    const [proses, setProses] = useState(0);
    const [tolak, setTolak] = useState(0);
    const [setuju, setSetuju] = useState(0);
    const page = 1;
    const perPage = 10;
    // const allInfo = JSON.parse(localStorage.allinfo);
    // const suratjalanso = String(allInfo.privileges.filter((i) => i.privilege_name === "Sub Surat Jalan SO").map((p) => p.read_access));
    // const permintaanBarang = String(allInfo.privileges.filter((i) => i.privilege_name === "Tab Surat Jalan SO").map((p) => p.read_access));
	// const validasiPermintaanBarang = String(allInfo.privileges.filter((i) => i.privilege_name === "Tab Validasi Surat Jalan SO Kepala").map((p) => p.read_access));
	// const cetak = String(allInfo.privileges.filter((i) => i.privilege_name === "Tab Cetak Surat Jalan SO").map((p) => p.read_access));
    
    useEffect(() => {
        gettotal();
        getProses();
        getTolak();
        getSetuju()
      }, []);
    
      // fungsi dari ambil data
      const gettotal = () => {
        let filter = { 
          page: page, 
          per_page: perPage,
          warehouse_id: parseInt(warehouse),
        };
        
        const data = filter;
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };
        axios
          .post(`${process.env.REACT_APP_API_BASE_URL}/surat-jalan-addendum/page`, data, {
            headers,
          })
          .then((data) => {
            setTotalItem(data.data.total_item);
          })
          .catch(function (error) {
          });
    }

    const getProses = () => {
        let filter = { 
          page: page, 
          per_page: perPage,
          status_sj : 3,
          warehouse_id: parseInt(warehouse),
        };
        
        const data = filter;
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };
        axios
          .post(`${process.env.REACT_APP_API_BASE_URL}/surat-jalan-addendum/page`, data, {
            headers,
          })
          .then((data) => {
            setProses(data.data.total_item);
          })
          .catch(function (error) {
          });
    }

    const getTolak = () => {
        let filter = { 
          page: page, 
          per_page: perPage,
          status_sj : 4,
          warehouse_id: parseInt(warehouse),
        };
        
        const data = filter;
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };
        axios
          .post(`${process.env.REACT_APP_API_BASE_URL}/surat-jalan-addendum/page`, data, {
            headers,
          })
          .then((data) => {
            setTolak(data.data.total_item);
          })
          .catch(function (error) {
          });
    }

    const getSetuju = () => {
        let filter = { 
          page: page, 
          per_page: perPage,
          status_sj : 5,
          warehouse_id: parseInt(warehouse),
        };
        
        const data = filter;
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };
        axios
          .post(`${process.env.REACT_APP_API_BASE_URL}/surat-jalan-addendum/page`, data, {
            headers,
          })
          .then((data) => {
            setSetuju(data.data.total_item);
          })
          .catch(function (error) {
          });
    }

    return (
    <>
      <SimpleHeader name="Surat Jalan Addendum" parentName="Report" />
      <HeaderTotal
       totalItem = {totalItem}
       proses ={proses}
       tolak={tolak}
       setuju={setuju}

      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
                <CardBody>
                    <Row>
                        <div className="card-columns">
                            {/* {permintaanBarang && permintaanBarang === "1" && ( */}
                            <Card>
                                <Link to="/admin/surat-jalan-addendum/page">
                                    <CardImg
                                        alt="..."
                                        src={require("assets/img/theme/surat-jalan-penjualan.png").default}
                                        top
                                    />
                                </Link>
                            </Card>
                        {/* )}
                        {validasiPermintaanBarang && validasiPermintaanBarang === "1" && ( */}
                            <Card>
                                <Link to="/admin/surat-jalan-addendum/validasi-kepala-gudang">
                                    <CardImg
                                        alt="..."
                                        src={require("assets/img/theme/validasi-kepala-gudang.png").default}
                                        top
                                    />
                                </Link>
                            </Card>
                        {/* )}
                        {cetak && cetak === "1" && ( */}
                            <Card>
                                <Link to="/admin/surat-jalan-addendum/histori">
                                    <CardImg
                                        alt="..."
                                        src={require("assets/img/theme/history.png").default}
                                        top
                                    />
                                </Link>
                            </Card>
                        {/* )} */}
                        </div>
					</Row>
                </CardBody>
          </div>
        </Row>
      </Container>
    </>
  );
}